import $ from "jquery";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";

$(document).ready(function () {
  const carousels = $(".bloc-carousel-card").find(".acf-innerblocks-container, .carousel-items");

  carousels.each(function () {
    const carousel = $(this);
    const block = carousel.closest(".bloc-carousel-card");

    carousel.addClass("owl-carousel");

    carousel.owlCarousel({
      loop: true,
      dots: false,
      margin: 12,
      items: 1,
      center: true,
      autoWidth: false,
      responsive: {
        600: {
          items: 2,
          center: false,
        },
        900: {
          items: 2,
          center: false,
        },
      },
    });

    const navLeft = block.find(".carousel-arrow.carousel-prev");
    const navRight = block.find(".carousel-arrow.carousel-next");

    navLeft.on("click", function () {
      carousel.trigger("prev.owl.carousel");
    });

    navRight.on("click", function () {
      carousel.trigger("next.owl.carousel");
    });
  });
});
